import React, { useState } from 'react';
import styles from './ReactivatePopup.module.css';

export default function ReactivatePopup(props) {
    const [fieldValue, setFieldValue] = useState('');

    const { onDone, themeColor = '#ad0028' } = props;

    const request = () => {
        const req = {
            code: fieldValue
        };
        onDone && onDone('done', req);
    }

    return (
        <div className={styles.container}>
            <div className={styles.heading}>Enter new activation code to reactivate the device</div>
            <div className={styles.container}>
                <input type="text" value={fieldValue} onChange={event => setFieldValue(event.target.value)} className={styles.textInput} />
            </div>
            <div className={styles.btnWrapper}>
                <button disabled={!fieldValue} className={styles.btns} style={{ opacity: !fieldValue ? 0.4 : 1, backgroundColor: themeColor }} onClick={request}>OK</button>
            </div>
        </div>
    );
};